import React from "react";
import TargetVotesCalculatorComponent from "./TargetVotesCalculator";

const TargetVotesCalculator = () => {
    return <TargetVotesCalculatorComponent />;
};

export default TargetVotesCalculator;
